var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('main',{staticClass:"sv-body"},[_c('nuxt')],1),_vm._v(" "),_c('willis-footer'),_vm._v(" "),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }